const base = process.env.REACT_APP_API_URL || '';

export const sendVerificationEmailViaApi = async (idToken) => {
  const res = await fetch(`${base}/api/auth/send-verification`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ idToken }),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    const err = new Error(data.error || 'Não foi possível enviar o email de verificação.');
    err.status = res.status;
    throw err;
  }

  return true;
};

export const sendPasswordResetViaApi = async (email) => {
  const res = await fetch(`${base}/api/auth/send-password-reset`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: email.trim() }),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    const err = new Error(data.error || 'Não foi possível enviar o email de redefinição.');
    err.status = res.status;
    throw err;
  }

  return true;
};
